/**
 * src/admin-ui/src/components/ThemeToggle.tsx
 *
 * Accessible light and dark theme toggle.
 */

import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';
import { useColorMode } from '../theme/ColorModeProvider';

/**
 * Render the application color-mode switch.
 *
 * :returns: Accessible icon button for the opposite color mode.
 */
export default function ThemeToggle(): React.ReactElement {
  const { mode, toggleColorMode } = useColorMode();
  const label = mode === 'light' ? 'Включить тёмную тему' : 'Включить светлую тему';

  return (
    <Tooltip title={label}>
      <IconButton color="inherit" onClick={toggleColorMode} aria-label={label}>
        {mode === 'light' ? <DarkMode /> : <LightMode />}
      </IconButton>
    </Tooltip>
  );
}
